import * as styles from './DataInsightsChart.css';

export const NoData = () => {
  return (
    <div className={styles.noDataText}>
      No data available for this time period
    </div>
  );
};
